import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { Button } from 'semantic-ui-react';

const ErrorPopupNotification = ({ open, message, handleClose }) => {

    return (
        <div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle id="alert-dialog-slide-title" className="popup-container-header">
                    Error
                </DialogTitle>
                <DialogContent className="dialog-body">
                    <div id="alert-dialog-slide-description">{message}</div>
                </DialogContent>
                <DialogActions>
                    <Button color="red" onClick={handleClose}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ErrorPopupNotification;

